/**
 * @generated SignedSource<<65b8bfef54b4e30b209f876346d73016>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskSellerItemsListItem_item$data = {
  readonly dealerReference: string | null;
  readonly dealerStatusDisplay: string | null;
  readonly dibsReference: string | null;
  readonly firstPhotoWebPath: string | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "GetHelpZendeskSellerItemsListItem_item";
};
export type GetHelpZendeskSellerItemsListItem_item$key = {
  readonly " $data"?: GetHelpZendeskSellerItemsListItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskSellerItemsListItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskSellerItemsListItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dealerReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dibsReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dealerStatusDisplay",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "bc08d212dcc466cc72a781a5e9b70a63";

export default node;
